/**
 * Enum for unique error codes. L stands for location
 */

export enum ErrorCodes {
  ERR001 = 'L001',
  ERR002 = 'L002',
  ERR003 = 'L003',
  ERR004 = 'L004',
  ERR005 = 'L005',
  ERR006 = 'L006',
  ERR007 = 'L007',
  ERR008 = 'L008',
  ERR009 = 'L009',
  ERR010 = 'L010',
  ERR011 = 'L011',
  ERR012 = 'L012',
  ERR013 = 'L013',
  ERR014 = 'L014',
  ERR015 = 'L015',
  ERR016 = 'L016',
  ERR017 = 'L017',
  ERR018 = 'L018',
  ERR019 = 'L019',
  ERR020 = 'L020',
  ERR021 = 'L021',
  ERR022 = 'L022',
  ERR023 = 'L023',
  ERR024 = 'L024',
  ERR025 = 'L025',
  ERR026 = 'L026',
  ERR027 = 'L027',
  ERR028 = 'L028',
  ERR029 = 'L029',
  ERR030 = 'L030',
  ERR031 = 'L031',
  ERR032 = 'L032',
  ERR033 = 'L033',
  ERR034 = 'L034',
  ERR035 = 'L035',
  ERR036 = 'L036',
  ERR037 = 'L037',
  ERR038 = 'L038',
  ERR039 = 'L039',
  ERR040 = 'L040',
  ERR041 = 'L041',
  ERR042 = 'L042',
  ERR043 = 'L043',
  ERR044 = 'L044',
  ERR045 = 'L045',
  ERR046 = 'L046',
  ERR047 = 'L047',
  ERR048 = 'L048',
  ERR049 = 'L049',
  ERR050 = 'L050',
}
